module.exports = __webpack_public_path__ + "media/images/official/icon_ticket-6579487fe3ab4ae8567709c3cb253b2d.svg";